import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BookingProvider } from "./context/BookingContext";
import { PricingProvider } from "./context/PricingContext";
import { PromoProvider } from "./context/PromoContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import BookSlot from "./pages/BookSlot";
import BookingForm from "./pages/BookingForm";
import PaymentSummary from "./pages/PaymentSummary";
import Confirmation from "./pages/Confirmation";
import Login from "./pages/Login";
import UserDashboard from "./pages/UserDashboard";
import AdminGuard from "./pages/AdminGuard";
import CancellationPolicy from "./pages/CancellationPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import FAQ from "./pages/FAQ";

export default function App() {
  return (
    <PricingProvider>
    <PromoProvider>
    <BookingProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-dark-900">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/book" element={<BookSlot />} />
              <Route path="/booking-form" element={<BookingForm />} />
              <Route path="/payment-summary" element={<PaymentSummary />} />
              <Route path="/confirmation" element={<Confirmation />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<UserDashboard />} />
              <Route path="/admin" element={<AdminGuard />} />
              <Route path="/cancellation-policy" element={<CancellationPolicy />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </BookingProvider>
    </PromoProvider>
    </PricingProvider>
  );
}
